// extracted by mini-css-extract-plugin
export default {"marquee":"Suggestions_marquee__i4X9L","track":"Suggestions_track__g3Ew5","maylike-products-container":"Suggestions_maylike-products-container__u9rfe"};